import type {PasswordResetChallenge,PasswordStatus,PasswordUpdateResult} from '@reados/contracts';
import {ApiError,request} from './api';

export const passwordUpdatedNotice='密码已更新，请重新登录';
export const passwordRevocationPendingNotice='密码已更新，正在退出其他会话，请稍后重新登录';
export const passwordResetNotice='若邮箱对应账号，你会收到验证码；请检查收件箱和垃圾邮件。';
const post=(body:unknown)=>({method:'POST',body:JSON.stringify(body)});
export const passwordApi={
 status:(signal?:AbortSignal)=>request<PasswordStatus>('/auth/password/status',{cache:'no-store',signal}),
 change:(currentPassword:string,newPassword:string)=>request<PasswordUpdateResult>('/auth/password/change',post({currentPassword,newPassword})),
 request:(email:string)=>request<PasswordResetChallenge>('/auth/password/reset/request',post({email})),
 resend:(challengeId:string)=>request<PasswordResetChallenge>('/auth/password/reset/resend',post({challengeId})),
 confirm:(challengeId:string,code:string,newPassword:string)=>request<PasswordUpdateResult>('/auth/password/reset/confirm',post({challengeId,code,newPassword}))
};

/** Passwords remain exact strings, including intentional leading/trailing spaces. */
export function newPasswordError(password:string,confirmation:string):string|null{
 if(password.length<12)return '新密码至少需要 12 个字符。';
 if(password.length>1024)return '新密码不能超过 1024 个字符。';
 if(password!==confirmation)return '两次输入的新密码不一致。';
 return null;
}

export function passwordResetTimers(challenge:PasswordResetChallenge,now=Date.now()){
 const expiresAt=Date.parse(challenge.expiresAt),resendAfter=Date.parse(challenge.resendAfter);
 if(!challenge.challengeId||!Number.isFinite(expiresAt)||!Number.isFinite(resendAfter))throw new Error('密码重置信息无效，请返回后重新获取验证码。');
 return {expiresIn:Math.max(0,Math.ceil((expiresAt-now)/1000)),resendIn:Math.max(0,Math.ceil((resendAfter-now)/1000))};
}

export function passwordResetMustRestart(error:unknown){
 return error instanceof ApiError&&(error.code==='PASSWORD_CHALLENGE_INVALID'||error.code==='PASSWORD_STATE_CHANGED');
}

/** This server code explicitly confirms the password transaction has committed. */
export function passwordUpdateNoticeForError(error:unknown):string|null{
 return error instanceof ApiError&&error.code==='PASSWORD_REVOCATION_PENDING'?passwordRevocationPendingNotice:null;
}

export function requirePasswordUpdate(result:PasswordUpdateResult){
 if(result?.ok!==true)throw new Error('服务端尚未确认密码已更新，请重试。');
}
